import { call, put, takeLatest } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { eHocLaiThiLaiActionIds, IHocLaiThiLaiActionTypes } from "../../action-types/hoc-lai-thi-lai/IHocLaiThiLaiActions";
import { hocLaiThiLaiApi } from "../../../api/hoc-lai-thi-lai/hocLaiThiLaiApi";
import { IHocLaiThiLaiRequest } from "../../../model/request/hoc-lai-thi-lai/IHocLaiThiLaiRequest";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
const mainActions = rootActions.hocLaiThiLai;

export function* hocLaiThiLaiSaga(): any {
    yield takeLatest(eHocLaiThiLaiActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IHocLaiThiLaiActionTypes): any {
    const request = action.payload as IHocLaiThiLaiRequest;
    const response: IBaseResponse = yield call(hocLaiThiLaiApi.SelectByLop, request);    
    if (response.is_success) {
        yield put(mainActions.LOAD_SUCCESS(response.data));
    } else {
        yield put(mainActions.LOAD_ERROR(response.message ?? "Có lỗi"));
    }
}
